import { postAPI } from '@/store/api';
import {
  UserLoginInfo,
  Activation,
  EmailReset,
  ConfirmResetPassword,
  JWT
} from '@/store/models/jwt';
import { Action } from '@/store/api/actions';
import type { SubscribeEventPayload } from '@/utils/event-bus';

export default new (class JWTAPI {
  public async getJWT(user: UserLoginInfo): Promise<JWT> {
    return await postAPI<JWT>(Action.Token, user, {
      withCredentials: true
    });
  }

  public async refreshAccessToken(): Promise<JWT | undefined> {
    try {
      return await postAPI<JWT>(
        Action.RefreshToken,
        {},
        {
          withCredentials: true
        }
      );
    } catch {
      return undefined;
    }
  }

  public async clearJWT(): Promise<void> {
    await postAPI(
      Action.ClearToken,
      {},
      {
        withCredentials: true
      }
    );
  }

  public async userActivation(data: Activation): Promise<{ message: string }> {
    return await postAPI(Action.Activation, data);
  }

  public async resendActivation(data: EmailReset): Promise<{ message: string }> {
    return await postAPI(Action.ResendActivation, data);
  }

  public async resetPassword(data: EmailReset): Promise<{ message: string }> {
    return await postAPI(Action.ResetPassword, data);
  }

  public async confirmResetPassword(
    data: ConfirmResetPassword
  ): Promise<{ message: string }> {
    return await postAPI(Action.ResetPasswordConfirm, data);
  }

  public async subscribe(data: SubscribeEventPayload): Promise<{ message: string }> {
    return await postAPI(Action.WebPushSubscribe, data);
  }
})();
